/* TREDWLL — le seul JavaScript que la page produit charge.
 *
 * ⛔ NE PAS remettre `custom.js` dans layout/theme.liquid.
 *    Ce fichier-là dort dans le thème depuis son achat et déclare
 *    `const KachingApp` au niveau global (ligne ~352). Il n'était jamais
 *    chargé. Le brancher le 05/08 pour ce simple défilement d'onglets a fait
 *    entrer `KachingApp` en collision avec le script de l'application Kaching
 *    Bundles — « Identifier 'KachingApp' has already been declared » — et le
 *    composant <kaching-bundle> ne s'enregistrait plus du tout : offre
 *    invisible, bloc à 0 px.
 *    D'où ce fichier séparé, qui ne contient que ce dont on a besoin.
 */

/* === TREDWLL — onglets §17 en défilement automatique === */
// Les six douleurs sont dans une section à onglets : replié, un visiteur qui
// ne clique pas ne voit qu'une douleur sur six. On fait donc tourner les
// onglets tout seuls, et on s'arrête dès qu'il en choisit un ou qu'il survole
// la section — sinon on lui reprend la main pendant sa lecture.
(function () {
  var DELAI = 6000;

  function armer(section) {
    var onglets = section.querySelectorAll('[class*="tab-button"], [class*="tab-btn"], [role="tab"], .content-tabs__tab');
    if (onglets.length < 2) return;

    var i = 0, arrete = false, minuteur = null;

    function stop() {
      arrete = true;
      if (minuteur) clearInterval(minuteur);
    }

    onglets.forEach(function (o, n) {
      o.addEventListener('click', stop);
      o.addEventListener('keydown', stop);
      if (o.getAttribute('aria-selected') === 'true' || o.classList.contains('active')) i = n;
    });
    section.addEventListener('mouseenter', function () { if (minuteur) clearInterval(minuteur); });
    section.addEventListener('mouseleave', function () { if (!arrete) demarrer(); });

    function demarrer() {
      if (minuteur) clearInterval(minuteur);
      minuteur = setInterval(function () {
        if (arrete) return;
        i = (i + 1) % onglets.length;
        onglets[i].click();
      }, DELAI);
    }

    // On n'anime que si la section est à l'écran : faire tourner des onglets
    // que personne ne regarde ne sert qu'à consommer de la batterie.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting && !arrete) demarrer();
          else if (minuteur) clearInterval(minuteur);
        });
      }, { threshold: 0.25 }).observe(section);
    } else {
      demarrer();
    }
  }

  function init() {
    var s = document.querySelector('[id^="shopify-section-"][id$="__s17_roots"]');
    if (s) armer(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* === fin TREDWLL onglets === */

/* Amorçage Kaching retiré le 05/08.
 * Il servait quand l'app embed n'était pas activé : le bloc n'émettait qu'un
 * `modulepreload`, jamais exécuté. L'embed activé fournit lui-même le runtime,
 * et injecter le module en parallèle faisait courir les deux — le module
 * s'exécutait avant que <kaching-bundle> existe, et l'élément ne
 * s'enregistrait plus. Une rustine qui survit à sa cause devient la panne
 * suivante.
 */
